const ReactUJS = require('components/react_ujs.js');
const { UI } = require('components/legacy/ui.js');

function rerenderCheckoutTotals(e) {
  const $checkoutTotals = $('[data-checkout-totals]');
  if ($checkoutTotals.length === 0) {
    return;
  }
  const url = $checkoutTotals.data('checkout-totals');
  const $form = $(e.target).closest('form');
  const ajax = $.ajax({
    url,
    type: 'PUT',
    data: $form.serialize(),
  });
  UI.spin(ajax, $checkoutTotals).done((data) => {
    $checkoutTotals.html(data);
    ReactUJS.init(window, $checkoutTotals[0]);
  });
}

function bindFieldChange() {
  $(document).on('change',
    ':input[data-update-checkout-totals], [data-update-checkout-totals] :input',
    rerenderCheckoutTotals);
}

function init() {
  bindFieldChange();
}


module.exports = { init };



// WEBPACK FOOTER //
// ./javascripts/components/bundled_checkout/checkout_totals.js